import { render, staticRenderFns } from "./SyariahIndexPage.vue?vue&type=template&id=72390a17&"
import script from "./SyariahIndexPage.vue?vue&type=script&lang=js&"
export * from "./SyariahIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports